import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";


// Components
import Home from "./components/Home";
import History from "./components/History";
import News from "./components/News";
import Contact from "./components/Contact";
import Menu from "./components/Menu";
import SiteFooter from "./components/SiteFooter";
import TermsAndConditions from "./components/TermsAndConditions";
import Administration from "./components/Administration";
import Accommodation from "./components/Accommodation";
import Timing from "./components/Timing";
import MainnMenu from "./components/MainMenu";
import Attract from "./components/Attract";
import PhotoGallery from "./components/PhotoGallery";
import Live from "./components/Live";
import Slider from "./components/Slider";
import NewsEvents from "./components/NewsEvents";
import Ithihyam from "./components/Ithihyam";
import Activities from "./components/Activities";
import Imagination from "./components/Imagination";
import PrivacyPolicy from "./components/PrivacyPolicy";
import BookingCarousel from "./components/BookingCarousel";
import PopupModal from "./components/PopupModal";

function App() {
	return (


		<Router>
			{/* <!-- Header --> */}
			<PopupModal />
			<header className="header">
				<MainnMenu />
			</header>
			<div >
				{/* Page Routes */}
				<div>
					<Routes>
					
						<Route path="/" element={<Home />} />
						{/* <Route path="home" element={<Home />} /> */}
						<Route path="/history" element={<History />} />
						<Route path="/accommodation" element={<Accommodation />} />
						<Route path="/contact" element={<Contact />} />
						<Route path="/termsandconditions" element={<TermsAndConditions />} />
						<Route path="/administration" element={<Administration />} />
						<Route path="/timing" element={<Timing />} />
						<Route path="/attract" element={<Attract />} />
						<Route path="/gallery" element={<PhotoGallery />} />
						<Route path="/live" element={<Live />} />
						<Route path="/Slider" element={<Slider />} />
						<Route path="/newsevents" element={<NewsEvents />} />
						<Route path="/ithihyam" element={<Ithihyam />} />
						<Route path="/activities" element={<Activities />} />
						<Route path="/imagination" element={<Imagination />} />
						<Route path="/privacypolicy" element={<PrivacyPolicy />} />
						<Route path="/bookingcarousel" element={<BookingCarousel />} />
					</Routes>
				</div>
			</div>
			<footer class="footer" style={{ backgroundImage: 'url(./images/11.jpg)', backgroundSize:'cover',backgroundPosition: 'center', padding: '0px' }}>
				<SiteFooter />
			</footer>
		</Router>
	);
}






export default App;
